var map = {
	"./Esri_Word_Imagery.png": 1311,
	"./LIO_Imagery.png": 1312,
	"./LIO_Topo.png": 1313,
	"./Simple_Background.png": 1314,
	"./about.png": 1315,
	"./arrow-down.png": 1316,
	"./arrow_curve.gif": 1317,
	"./blank-background.png": 1318,
	"./capture.png": 1319,
	"./compass.png": 1320,
	"./copy16.png": 1321,
	"./down.png": 1322,
	"./edit.png": 1323,
	"./emergency.png": 1324,
	"./esri-streets.png": 1325,
	"./extent-zoom-in.png": 1326,
	"./feedback-footer.png": 1327,
	"./feedback.png": 1328,
	"./globe-icon.png": 1329,
	"./help.png": 1330,
	"./identify.png": 1331,
	"./information.png": 1332,
	"./legend-footer.png": 1333,
	"./legend.png": 1334,
	"./lio-topo.png": 1335,
	"./loading.gif": 1336,
	"./mappa-base.png": 1337,
	"./mappa-google-satellitare-strade.png": 1338,
	"./mappa-google-satellitare.png": 1339,
	"./mappa-google-strade-senza-costruzioni.png": 1340,
	"./mappa-google-strade.png": 1341,
	"./mappa-google-terreno.png": 1342,
	"./mappa-open-street-map.png": 1343,
	"./mappa-topografica.png": 1344,
	"./menu.png": 1345,
	"./metadata.png": 1346,
	"./myMaps.png": 1347,
	"./other.png": 1348,
	"./pdf.png": 1349,
	"./print.png": 1350,
	"./school.png": 1351,
	"./screenshot.png": 1352,
	"./settings.png": 1353,
	"./tab-close.png": 1354,
	"./tab-open.png": 1355,
	"./target.png": 1356,
	"./terms-footer.png": 1357,
	"./terms.png": 1358,
	"./themes.png": 1359,
	"./tools.png": 1360,
	"./topo-blank.png": 1361,
	"./up.png": 1362,
	"./waste.png": 1363,
	"./zoom-in.png": 1364
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 530;